import { render, staticRenderFns } from "./statusItem.vue?vue&type=template&id=324fd0ab&scoped=true"
import script from "./statusItem.vue?vue&type=script&lang=js"
export * from "./statusItem.vue?vue&type=script&lang=js"
import style0 from "./statusItem.vue?vue&type=style&index=0&id=324fd0ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fd0ab",
  null
  
)

export default component.exports